import PodcastLayout, { PodcastContext } from "./PodcastLayout";

export { PodcastContext };

export default PodcastLayout;
